export default function getAvatarText(text?: string | null) {
  if (text) {
    const words = text.split(' ');
    const firstLetter = words[0].charAt(0).toUpperCase();
    const secondLetter = words[1]?.charAt(0).toUpperCase() || '';
    return `${firstLetter}${secondLetter}`;
  }
  return '';
}
